import logo from 'tmrAssets/images/logo-big.png'

/**
 * Controller of component {@link tmrLogin}
 *
 * @type {ngController}
 */
export class tmrLoginController {
  static ngType = 'controller'

  constructor(
    $state,
    TmrApiAuth,
    TmrInvalidCredentialsError,
    TmrConnectionTimeoutError
  ) {
    'ngInject'
    Object.assign(this, {
      $state,
      TmrApiAuth,
      TmrInvalidCredentialsError,
      TmrConnectionTimeoutError,
      logo,
    })
    this.ssoUrl = process.env.tmrEnv.ssoUrl
    this.isFormVisible = !this.ssoUrl
  }

  $onInit() {
    if (this.loginAs) this.credentials = { username: this.loggedUser.username }
  }

  submit({ username, password }) {
    this.invalidCredentials = false
    this.connectionTimeout = false
    let promise
    if (this.loginAs)
      promise = this.TmrApiAuth.loginAs({
        username,
        password,
        as: this.loginAs,
      })
    else promise = this.TmrApiAuth.login({ username, password })
    return promise.then(
      () => this.onSubmit(),
      err => this.loginError(err)
    )
  }

  loginError(err) {
    // Catch only wrong username/password and timeout errors.
    this.invalidCredentials = err instanceof this.TmrInvalidCredentialsError
    this.connectionTimeout = err instanceof this.TmrConnectionTimeoutError
    if (!this.invalidCredentials && !this.connectionTimeout) throw err
  }

  toggleForm() {
    this.isFormVisible = !this.isFormVisible
  }
}
